__turbopack_context__.v({
  "checkboxContainer": "questionFields-module-scss-module__aGadYq__checkboxContainer",
  "explanationIcon": "questionFields-module-scss-module__aGadYq__explanationIcon",
  "explanationIconContainer": "questionFields-module-scss-module__aGadYq__explanationIconContainer",
});
